import React from 'react';
import LocationTemplate from './LocationTemplate';

const WhitakersPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Whitakers"
      stateName="North Carolina"
      countyName="Nash/Edgecombe"
      zipCodes={["27891"]}
      latitude={36.1068}
      longitude={-77.7161}
      population={1310}
      historicalFact="Named after Richard Whitaker, who donated land for a railroad station in the 1800s."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Enfield, NC",
        "Halifax, NC",
        "Speed, NC",
        "Leggett, NC",
        "Nashville, NC",
        "Red Oak, NC",
        "Scotland Neck, NC"
      ]}
    />
  );
};

export default WhitakersPage;